export const SCHEDULE_WITH_CONTACT_PROVIDER = {
  PARENT_COMPONENT: {
    CONTACT_PROFILE: 'CONTACT_PROFILE',
    CONTACT_LIST: 'CONTACT_LIST',
    MEETINGS_PAGE: 'MEETINGS_PAGE',
  }
}

export const CONTACT_BY_EMAIL_QUERY = `
  query ContactByEmail($email: String!) {
    contactByEmail(email: $email) {
      avatarUrl
      city
      company
      country
      createdAt
      emails
      firstEmailAt
      firstMeeting
      firstMeetingWith
      fullName
      id
      jobTitles
      lastEmailAt
      lastInteractionAt
      lastMeeting
      lastMeetingWith
      linkedinUrls
      nextMeeting
      nextMeetingWith
      state
      timezone
    }
  }
`
